let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4fuEt")).then(() => parcelRequire('bhyNF'));